import {invisiblyApi} from "../api/invisibly-api";
import {PaymentCreationResponse, PaymentStatusData, PaymentStatusResponse} from "./payment.types";
import { SimpleSurveyPricing} from "../../services/firebase/firebase.types";
import {SurveyStatus} from "../survey/survey.types";
import {surveyEndpoints} from "../survey/survey.endpoints";

const paymentEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    createInvoice: builder.mutation<void, { extSurveyId: string }>({
      query: ({ extSurveyId }) => ({
        data: {},
        method: 'post',
        url: `payment/invoice/${extSurveyId}`,
      }),
      async onQueryStarted({extSurveyId}, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(surveyEndpoints.util.updateQueryData('getSurvey', { ext_survey_id: extSurveyId }, (draft) => {
            const patch = draft;
            patch.surveyStatus = SurveyStatus.Live;
            Object.assign(draft, patch);
          }));
        } catch (error) {
          console.error('create invoice error:', error);
        }
      },
    }),
    createPayment: builder.mutation<{clientSecret: string, paid: boolean}, { extSurveyId: string, pricing: SimpleSurveyPricing }>({
      query: ({ extSurveyId, pricing }) => ({
        data: {
          ext_survey_id: extSurveyId,
          per_human_respondent_price: pricing.perHumanRespondentPrice,
          per_human_criteria_price: pricing.perHumanCriteriaPrice,
          per_ai_respondent_price: pricing.perAIRespondentPrice,
          per_ai_criteria_price: pricing.perAICriteriaPrice},
        method: 'post',
        url: 'payment',
      }),
      transformResponse: (response: PaymentCreationResponse) => {
        return {
          clientSecret: response.item.client_secret,
          paid: response.item.paid,
        };
      },
    }),
    getPaymentStatus: builder.query<PaymentStatusData, { sessionId: string }>({
      query: ({ sessionId }) => ({
        method: 'get',
        url: `payment/status/${sessionId}`,
      }),
      transformResponse: (response: PaymentStatusResponse) => ({
        sessionPaymentStatus: response.item.session_payment_status,
        extSurveyId: response.item.ext_survey_id,
        surveyStatus: response.item.survey_status as SurveyStatus,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled;
          const surveyId = response.data.extSurveyId;
          const status = response.data.surveyStatus;
          if (surveyId && status) {
            dispatch(surveyEndpoints.util.updateQueryData('getSurvey', { ext_survey_id: surveyId }, (draft) => {
              const patch = draft;
              patch.surveyStatus = status;
              Object.assign(draft, patch);
            }));
          }
        } catch (error) {
          console.error('payment status error:', error);
        }
      },
    }),
  }),
  overrideExisting: true,
});

export const { useCreateInvoiceMutation, useCreatePaymentMutation, useGetPaymentStatusQuery } = paymentEndpoints;
